import React, { useEffect, useState } from 'react';

const InteractionLoggerWithTimer = ({ upptackaIntegration }) => {
  console.log('entered InteractionLoggerWithTimer');

  // State to track if 10 seconds have passed
  const [allowInteractionLogging, setAllowInteractionLogging] = useState(false);

  const logInteraction = () => {
    // Reset the allowInteractionLogging to false to restart the timer
    upptackaIntegration.userInteraction();
    setAllowInteractionLogging(false);
  };

  // Set up the timer that enables the event listeners after 10 seconds
  useEffect(() => {
    const timerId = setTimeout(() => {
      setAllowInteractionLogging(true);
    }, 10000); // 10 seconds

    return () => {
      clearTimeout(timerId);
    };
  }, [allowInteractionLogging]); 

  // Set up or remove event listeners depending on the allowInteractionLogging state
  useEffect(() => {
    if (allowInteractionLogging) {
      document.addEventListener('keydown', logInteraction);
      document.addEventListener('mousedown', logInteraction);
      document.addEventListener('touchstart', logInteraction);
    } else {
      // Remove event listeners before the 10-second mark
      document.removeEventListener('keydown', logInteraction);
      document.removeEventListener('mousedown', logInteraction);
      document.removeEventListener('touchstart', logInteraction);
    }

    return () => {
      document.removeEventListener('keydown', logInteraction);
      document.removeEventListener('mousedown', logInteraction);
      document.removeEventListener('touchstart', logInteraction);
    };
  }, [allowInteractionLogging]);

  // Since we don't want to render any UI, we return null
  return null;
};

export default InteractionLoggerWithTimer;